
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLightSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.99 2c3.473 0 6.353 2.957 6.374 6.587 0 2.196-1.059 4.109-2.541 5.218v1.63c0 .456-.382.826-.826.87l-5.825.477h-.084a.858.858 0 0 1-.593-.238c-.17-.152-.318-.392-.318-.63v-2.132c-1.694-1.195-2.54-2.978-2.54-5.195C5.636 4.957 8.516 2 11.99 2Zm-.001 1.74c-2.562 0-4.66 2.173-4.638 4.847 0 1.783.679 3.087 2.14 3.957a.9.9 0 0 1 .38.76v1.675l4.236-.348v-1.326c0-.305.149-.609.424-.761 1.334-.74 2.096-2.218 2.117-3.957 0-2.674-2.097-4.848-4.66-4.848Z",
  fill: "var(--theme-primary, #810ea9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.53 12.543c-.275.153-.423.457-.423.761v1.326l-4.235.348v-1.674a.899.899 0 0 0-.382-.76c-1.46-.87-2.139-2.175-2.139-3.957-.02-2.674 2.076-4.848 4.638-4.848 2.563 0 4.66 2.174 4.66 4.848-.022 1.739-.784 3.217-2.119 3.956Z",
  fill: "var(--theme-bright, #e3d2e9)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m14.933 19.087-5.781.435h-.063c-.445 0-.805-.348-.848-.805a.867.867 0 0 1 .784-.934l5.781-.435a.835.835 0 0 1 .91.804.867.867 0 0 1-.783.935ZM13.09 21.826 11.017 22h-.064c-.445 0-.805-.348-.847-.804a.867.867 0 0 1 .784-.935l2.096-.174a.842.842 0 0 1 .89.804.867.867 0 0 1-.784.935ZM15.357 8.565c-.043.392-.36.696-.741.696h-.064a.75.75 0 0 1-.656-.826c.127-1.24-.932-1.696-1.06-1.74a.79.79 0 0 1-.444-.978c.127-.39.55-.608.932-.456.783.283 2.223 1.348 2.033 3.304Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M11.9897 2C15.4625 2.00026 18.3426 4.95665 18.3638 8.58691C18.3638 10.7825 17.3051 12.696 15.8228 13.8047V15.4346C15.8228 15.891 15.4412 16.2611 14.9966 16.3047L9.17236 16.7822H9.08838C8.87661 16.7822 8.64287 16.6961 8.49463 16.5439C8.32524 16.3918 8.17725 16.1522 8.17725 15.9131V13.7822C6.48332 12.5866 5.63623 10.8042 5.63623 8.58691C5.63626 4.9565 8.51676 2 11.9897 2ZM11.9888 3.73926C9.42655 3.73948 7.32991 5.91314 7.35107 8.58691C7.35107 10.3695 8.02952 11.6744 9.49072 12.5439C9.7445 12.7179 9.87158 13.0005 9.87158 13.3047V14.9785L14.1069 14.6309V13.3047C14.1069 13.0003 14.2555 12.6961 14.5308 12.5439C15.8649 11.8048 16.6268 10.326 16.6479 8.58691C16.6479 5.91301 14.5512 3.73926 11.9888 3.73926Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<path d=\"M14.5304 12.5434C14.2551 12.6956 14.1069 13 14.1069 13.3043V14.6304L9.87153 14.9782V13.3043C9.87153 13 9.74447 12.7174 9.49034 12.5434C8.02914 11.6739 7.35148 10.3695 7.35148 8.58691C7.3303 5.91299 9.42681 3.73907 11.9892 3.73907C14.5516 3.73907 16.6481 5.91299 16.6481 8.58691C16.627 10.326 15.8646 11.8043 14.5304 12.5434Z\" fill=\"var(--theme-bright, #e3d2e9)\"/>\r\n<path d=\"M14.9333 19.0869L9.15203 19.5217H9.0885C8.64379 19.5217 8.28378 19.1739 8.24143 18.7173C8.19907 18.2391 8.55908 17.826 9.02497 17.7826L14.8063 17.3478C15.2933 17.3043 15.6957 17.6739 15.7169 18.1521C15.7592 18.6304 15.3992 19.0434 14.9333 19.0869Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<path d=\"M13.0909 21.8261L11.0156 22H10.952C10.5073 22 10.1473 21.6522 10.105 21.1957C10.0626 20.7174 10.4226 20.3044 10.8885 20.2609L12.985 20.087C13.4509 20.0652 13.8533 20.4131 13.8744 20.8913C13.9168 21.3696 13.5568 21.7826 13.0909 21.8261Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<path d=\"M15.3567 8.56531C15.3144 8.95662 14.9967 9.26097 14.6156 9.26097H14.552C14.1497 9.21749 13.8532 8.84792 13.8955 8.43488C14.0226 7.19574 12.9638 6.73922 12.8367 6.69574C12.4555 6.54357 12.2649 6.10879 12.392 5.71748C12.519 5.32617 12.9426 5.10878 13.3238 5.26096C14.1073 5.54357 15.5473 6.60879 15.3567 8.56531Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/light-small.d18309ae350d74abaf84409e0f5df33b.svg"),
        {
          React: SvgLightSmall,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      